import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {injectIntl} from "react-intl";
import './index.scss'
import __i18n from "../../../intl/__i18n";

function ReportsChart({data, intl}) {
  const {formatMessage} = intl;
  return(
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column'
          },
          title: {
            text: ""
          },
          xAxis: {
            type: 'category',
            labels: {
              rotation: -45,
              style: {
                fontSize: '12px',
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: __i18n("Sum Price")
            }
          },
          legend: {
            enabled: false
          },
          tooltip: {
            enabled: false
          },
          series: [{
            name: 'Population',
            data: data.map(item => ([ item.title, item.sum_price ])),
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: '#FFFFFF',
              align: 'right',
              // format: '{point.y:.1f}', // one decimal
              y: 10, // 10 pixels down from the top
              style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
              }
            }
          }]
        }}
      />
    </div>
  )
}

export default injectIntl(ReportsChart);

